import React from 'react'
import {
  CFView,
  CFImage,
  CFSelect,
  DefaultScreen,
  MobileScreen,
} from 'components'
import {
  foodGallery,
  foodGalleryNewWest,
  foodGalleryBroadway,
  mobileGallery,
  mobileGalleryNewWest,
  mobileGalleryBroadway,
} from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => {
        let GalleryMobileImage = null
        let GalleryImage = null
        if (locationId === 'E9UStmw0kdZVDzKDvHha') {
          GalleryImage = foodGallery
          GalleryMobileImage = mobileGallery
        } else if (locationId === 'QUur6QgTAFdRHKCv2Oku') {
          GalleryImage = foodGalleryNewWest
          GalleryMobileImage = mobileGalleryNewWest
        } else {
          GalleryImage = foodGalleryBroadway
          GalleryMobileImage = mobileGalleryBroadway
        }
        return (
          <CFView>
            <MobileScreen>
              <CFView column center>
                <CFImage src={GalleryMobileImage} w="100%" alt="Food Gallery" />
              </CFView>
            </MobileScreen>
            <DefaultScreen>
              <CFView column center maxWidth="1400px" mt="-1px">
                <CFImage src={GalleryImage} w="100%" alt="Food Gallery" />
              </CFView>
            </DefaultScreen>
          </CFView>
        )
      }}
    </CFSelect>
  )
}
